module.exports = __webpack_public_path__ + "static/guayaquil-ba744f9ec30dc56a0867957682868331.jpg";